module.exports = __webpack_public_path__ + "static/media/home-bgImage.9be29f2c.svg";